/* cart-utils.js  ––  one place for all Dawn-style cart helpers  */
(function attachCartUtils (w) {
  if (w.CartUtils) return;        // guard if you include it twice

  /* ---- SECTION HELPERS (copied from size-modal.js) ---- */
  const getSectionsToRender = () => [
    { id: 'main-cart-items',
      section: document.getElementById('main-cart-items')?.dataset.id || 'main-cart-items',
      selector: '.js-contents' },
    { id: 'cart-icon-bubble',       section: 'cart-icon-bubble',       selector: '.shopify-section' },
    { id: 'cart-live-region-text',  section: 'cart-live-region-text',  selector: '.shopify-section' },
    { id: 'main-cart-footer',
      section: document.getElementById('main-cart-footer')?.dataset.id || 'main-cart-footer',
      selector: '.js-contents' },
    { id: 'cart-drawer',            section: 'cart-drawer',            selector: '.shopify-section' },
  ];

  const getSectionInnerHTML = (html, selector) =>
    new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;

  const updateLiveRegions = (state) => {
    const region = document.getElementById('cart-live-region-text')
               || document.getElementById('CartDrawer-LiveRegionText');
    if (!region) return;
    region.setAttribute('aria-hidden', false);
    setTimeout(() => region.setAttribute('aria-hidden', true), 1e3);
  };

  const updateCartSections = (state) => {
    /* toggle empty-state */
    document.querySelectorAll('cart-items, cart-drawer').forEach(el =>
      el.classList.toggle('is-empty', state.item_count === 0));
    const footer = document.getElementById('main-cart-footer');
    if (footer) footer.classList.toggle('is-empty', state.item_count === 0);

    /* replace HTML for every watched section */
    getSectionsToRender().forEach(({ id, section, selector }) => {
      const target = document.getElementById(id)?.querySelector(selector)
                 || document.getElementById(id);
      if (target && state.sections?.[section])
        target.innerHTML = getSectionInnerHTML(state.sections[section], selector);
    });

    updateLiveRegions(state);
  };

  const openCartDrawer = (state) => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    typeof drawer.renderContents === 'function'
      ? drawer.renderContents(state)
      : drawer.open?.();
  };

  /* ---- A generic “add/change & refresh” helper ---- */
  const mutateCartAndRefresh = async ({ url, body, source }) => {
    const sections = getSectionsToRender();
    body.append('sections', sections.map(s => s.section).join(','));
    body.append('sections_url', window.location.pathname);

    const resp   = await fetch(url, {
      method  : 'POST',
      headers : { 'X-Requested-With': 'XMLHttpRequest',
                  'Accept'          : 'application/javascript' },
      body
    });
    const state  = await resp.json();
    if (state.status) throw new Error(state.description || state.message);

    updateCartSections(state);
    openCartDrawer(state);

    if (typeof publish !== 'undefined' &&
        typeof PUB_SUB_EVENTS !== 'undefined')
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source, cartData: state
      });

    return state;
  };

  /* ---- expose ---- */
  w.CartUtils = {
    getSectionsToRender,
    mutateCartAndRefresh      // used by both size-modal.js *and* gift-bot.js
  };
})(window);
